import React from 'react';
interface HubspotIconProps {
  className?: string;
  size?: number;
}
const HubspotIcon: React.FC<HubspotIconProps> = ({
  className = '',
  size = 16
}) => {
  return <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nLUtKPcgGgSRHwsSAVxawb/hubspot-icon-1849091993.png" alt="HubSpot" width={size} height={size} className={className} style={{
    objectFit: 'contain'
  }} data-id="element-118" />;
};
export default HubspotIcon;